export const INSTITUTION = 'institution' // 机构
export const CLINIC = 'clinic' // 诊所
export const EMPLOYEE = 'employee' // 员工
export const COMMON = 'common' // 公共
export const DICT = 'dict' // 字典
export const LIST = 'list' // 列表
export const CONFIG = 'config' // 配置
export const SOURCE = 'source' // 号源规则
export const SLOT = 'slot' // 号源設定
export const PROJECT = 'project' // 項目管理
export const ACUPUNCTURE = 'acupuncture' // 針灸管理
export const BONING = 'boning' // 推拿/正骨
export const CUPPING = 'cupping' // 拔罐管理
export const ROLE = 'role' // 角色管理
export const USER = 'user' // 用户管理
export const PATIENT = 'patient' // 患者列表
export const PROMOTION = 'promotion' // 轉介碼
export const PROXY = 'proxy' // 授權管理
export const MEDICATION = 'medication' // 藥品管理
export const INVENTORY = 'inventory' // 藥品庫存
export const PROCUREMENT = 'procurement' // 藥品採購
export const STOCKTAKING = 'stocktaking' // 藥品盘点
export const ADJUSTMENT = 'adjustment' // 藥品調整
export const REVENUE = 'revenue' // 營收管理
export const FEE = 'fee' // 收費設定
export const DISCOUNT = 'discount' // 優惠管理
export const COUPON = 'coupon' // 優惠券
export const EVENTS = 'events' // 儲值活動
export const CLIENT = 'client' // 儲值用戶
export const SETMEAL = 'setmeal' // 套票管理
export const DISEASE = 'disease' // 匹配藥物
export const RETAIL = 'retail' // 診所零售
export const DRUG = 'drug' // 藥品零售
export const ACTIVITIES = 'activities' // 零售活動
export const STATISTICS = 'statistics' // 查詢統計
export const SUMMARY = 'summary' // 對賬單
export const PRINTRECORD = 'printrecord' // 打印日誌
export const LOG = 'log' // 日誌
export const LOGINLOG = 'loginlog' // 登錄日誌
export const TABOO = 'taboo' // 配伍禁忌
export const SENSITIVE = 'sensitive' // 敏感禁忌
export const ORG = 'org' // 組織管理
export const TRACKING = 'tracking' // 庫存追蹤
export const THIRDPARTY = 'thirdparty' // 第三方
export const AUTHORIZE = 'authorize' // 秘鑰管理
